import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { KN_BR_CUSTOMER_CURRENT, KNBR_REQUEST_QUOTE_DETAILS } from 'src/constants/api.endpoints.constant';
import { KnBrCustomerContextService } from '../store/kn-br-customer-context/kn-br-customer-context.service';

@Injectable({
  providedIn: 'root',
})
export class RequestQuoteListService {
  customerId: string;

  constructor(
    private endPointService: OccEndpointsService,
    private httpClient: HttpClient,
    private knBrCustomerContextService: KnBrCustomerContextService
  ) {
    this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
    });
  }

  getRequestQuoteDetails(quoteId: string): Observable<any> {
    const activeCustomerId = this.customerId || KN_BR_CUSTOMER_CURRENT;
    const url = this.endPointService.buildUrl(KNBR_REQUEST_QUOTE_DETAILS, {
      urlParams: {
        customerId: activeCustomerId,
        quoteId,
      }
    });

    return this.httpClient.get(url);
  }
}
